import { render, staticRenderFns } from "./login.vue?vue&type=template&id=36b9b9e6&scoped=true"
import script from "./login.js?vue&type=script&lang=js&external"
export * from "./login.js?vue&type=script&lang=js&external"
import style0 from "./login.vue?vue&type=style&index=0&id=36b9b9e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b9b9e6",
  null
  
)

export default component.exports